"use client";

import { motion, AnimatePresence } from "framer-motion";
import { useState } from "react";
import "./style.css";
import CallIcon from "@mui/icons-material/Call";
import { Link } from "react-router-dom";
export default function FloatingContact() {
  const [isExpanded, setIsExpanded] = useState(true);

  const handleClick = () => {
    setIsExpanded((prev) => !prev);
  };

  return (
    <Link
    style={{ textDecoration: "none", color: "black" }}
    to="tel:+1 (844) 245-7422"
  >
    <motion.div
      className={`floating-contact ${isExpanded ? "expanded" : ""}`}
      initial={{ width: "120px", height: "60px" }}
      animate={{
        width: isExpanded ? "265px" : "265px",
        height: isExpanded ? "65px" : "65px",
        borderRadius: isExpanded ? "44px" : "44px",
      }}
      transition={{
        duration: 0.3,
        ease: "easeInOut",
      }}
    >
      <div
        className={`contact-header`}
    
      >
       
          <motion.div
            className="phone-container"
            animate={{
              scale: [1, 1.2, 1],
            }}
            transition={{
              duration: 0.5,
              repeat: Infinity,
              repeatType: "reverse",
            }}
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4.7144 1.03729C5.66607 1.73146 6.40763 2.67948 7.04168 3.58585L7.41003 4.12231L7.7575 4.63459C8.1145 5.15684 8.02925 5.86988 7.54425 6.28964L5.91832 7.49713C5.75716 7.61688 5.70358 7.83438 5.80023 8.01029C6.16811 8.67996 6.82349 9.67646 7.5735 10.4265C8.32425 11.1772 9.36784 11.8749 10.0835 12.2842C10.2691 12.3903 10.5025 12.3289 10.6198 12.1501L11.6776 10.5389C12.0833 9.99913 12.8407 9.88121 13.3913 10.2623L13.9444 10.6445C14.9765 11.3611 16.0865 12.1753 16.9342 13.261C17.2188 13.6255 17.2611 14.1021 17.0913 14.4983C16.394 16.1255 14.6293 17.5112 12.7937 17.4436L12.5432 17.4297L12.3491 17.413L12.1343 17.3889L11.8996 17.3563L11.6461 17.3142C11.6023 17.3063 11.5577 17.2979 11.5125 17.2891L11.2321 17.2303C11.184 17.2195 11.1352 17.2081 11.0857 17.1962L10.7806 17.1182L10.4602 17.0259L10.1252 16.9181C8.5866 16.3969 6.63426 15.372 4.63113 13.3688C2.62797 11.3656 1.60305 9.4133 1.08178 7.8747L0.974046 7.53975L0.881732 7.2193L0.803685 6.91425L0.738748 6.62547C0.719159 6.53202 0.701562 6.44143 0.685764 6.35385L0.643575 6.10028L0.611023 5.86564L0.586953 5.65082L0.570206 5.4567L0.556285 5.20627C0.48896 3.37672 1.89046 1.59906 3.51013 0.90492C3.89018 0.742036 4.3505 0.771845 4.7144 1.03729ZM11.4931 4.03281L11.5898 4.04417C12.1963 4.15112 12.7535 4.44737 13.1814 4.89044C13.6093 5.3335 13.8858 5.90065 13.9716 6.5106C14.0357 6.96636 13.7181 7.38771 13.2623 7.45179C12.8391 7.5113 12.4455 7.24173 12.3402 6.83801L12.3212 6.74255C12.2844 6.48115 12.1658 6.23809 11.9825 6.0482C11.8297 5.88996 11.6384 5.77542 11.4284 5.71511L11.3003 5.68551C10.8472 5.6056 10.5445 5.17338 10.6244 4.72014C10.6986 4.29926 11.0766 4.00825 11.4931 4.03281ZM11.5 1.49987C12.1566 1.49987 12.8068 1.62919 13.4134 1.88047C14.0201 2.13174 14.5713 2.50004 15.0356 2.96434C15.4998 3.42863 15.8682 3.97983 16.1194 4.58645C16.3707 5.19308 16.5 5.84326 16.5 6.49987C16.5 6.9601 16.1269 7.3332 15.6667 7.3332C15.2393 7.3332 14.8871 7.0115 14.8389 6.59705L14.8333 6.49987C14.8333 6.06213 14.7472 5.62868 14.5796 5.22426C14.4121 4.81984 14.1666 4.45238 13.857 4.14284C13.5475 3.83332 13.1801 3.58779 12.7756 3.42027C12.4386 3.28067 12.0814 3.19753 11.7184 3.1737L11.5 3.16654C11.0398 3.16654 10.6667 2.79344 10.6667 2.3332C10.6667 1.87297 11.0398 1.49987 11.5 1.49987Z"
                fill="white"
              />
            </svg>
          </motion.div>
      

        <div className="toll-free">
          <AnimatePresence>
            <motion.div className="contact-content">
              <div style={{fontWeight:"bold"}} > Toll Free</div>
              <Link
                style={{ textDecoration: "none", color: "black", fontWeight:"bold", fontSize:"15px"  }}
                to="tel:+1 (844) 245-7422"
              >
                +1 (844) 245-7422
              </Link>
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </motion.div>
    </Link>
  );
}
